import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import CheckBox from '~/Common-Objects/UI/Forms/CheckBox/CheckBox'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import i18n from '~/i18n'
import EmailValidator from '~/Classes/emailValidator'
import axios from '~/data/http/axios'
import postHogFunctions from '~/Classes/posthog';
const moment = require('moment');
export default function SendInstructions({ domain = {}, setFlowStep = () => { }, updateDomain = () => { } }) {

    const site = useSelector((state) => state.siteMaster)
    const [emailAddress, setEmailAddress] = useState("");
    const [emailError, setEmailError] = useState("");
    const [inviteToAccount, setInviteToAccount] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            forwardInstructions();
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        if (domain?.options?.forwardedInstructionsEmail) {
            setEmailAddress(domain.options.forwardedInstructionsEmail);
        }
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);


    const forwardInstructions = async () => {
        setIsLoading(true);
        setEmailError("");
        if (emailAddress == "") return setEmailError("Email address is required");
        if (!EmailValidator.validateEmail(emailAddress)) return setEmailError("Invalid email address");
        try {
            await axios.post(`/accountMaster/domain/${domain.id}/forwardInstructions`, {
                emailAddress: emailAddress,
                inviteToAccount: inviteToAccount
            });
            postHogFunctions.capture("authenticate_domain_instructions_forwarded");
            await updateDomain({
                options: {
                    trackingEnabled: true,
                    cdnEnabled: true,
                    doneDnsInstructions: true,
                    forwardedInstructions: true,
                    forwardedInstructionsEmail: emailAddress,
                    serviceProvider: "NONE",
                    doneDnsIntro: true,
                    lastAuthenticationCheckDate: moment().toDate()
                }
            })
            await axios.put(`/accountMaster/domain/${domain.id}/finishDomainSetup`);
            setFlowStep("verifySetup");
        } catch (error) {
            console.log(error);
            let errorMessage = "An error occurred while forwarding instructions";
            if (error?.response?.data?.message) errorMessage = error.response.data.message;
            setEmailError(errorMessage);
            setIsLoading(false);
        }
    }


    if (isLoading) {
        return <LoadingIcons iconType="2" style={{ top: 0 }} />
    }
    return (
        <>
            <h2 className='mar-b15 text-center'>{i18n.t('company:domains.domainManagement.forwardHeader')}</h2>
            <div className='mar-b40 text-center text-grey-800' style={{ lineHeight: '1.5' }}>
                {i18n.t('company:domains.domainManagement.forwardDesc')}
            </div>
            <div style={{ width: "100%" }} className="mar-b25">
                <TextInput name="emailAddress" label={i18n.t('company:domains.emailAddressLabel')} value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} error={emailError} placeholder="email@address.com" />
            </div>
            <div style={{ width: "100%", display: "flex" }} className="mar-b40">
                <CheckBox name="inviteToAccount" label="" checked={inviteToAccount} onChange={(e) => { setInviteToAccount(e.target.checked) }} />
                <div>
                    <div className="text-sml text-heavy">{i18n.t('company:domains.domainManagement.inviteAdmin', { siteName: site.siteName })}</div>
                    <div className="text-sml text-grey-800">{i18n.t('company:domains.domainManagement.inviteAdminDesc')}</div>
                </div>
            </div>
            <div style={{ width: "100%" }}>
                <Button onClick={forwardInstructions} text={i18n.t('company:domains.domainManagement.forwardButton')} className="button-primary" iconRight={<Icons icon='arrowRight' color='#FFFFFF' style={{ width: "20px", height: "20px" }} />} />
            </div>
        </>
    )
}